/** Nederlandstalige labels voor de statusweergave (US01). */
export const RUN_STATUS_LABELS = {
    CREATED: 'Aangemaakt',
    PROFILE_QUEUED: 'Profiel in wachtrij',
    PROFILE_RUNNING: 'Profiel wordt opgesteld',
    PROFILE_REVIEW_REQUIRED: 'Profiel controleren',
    COMPETITOR_DISCOVERY_QUEUED: 'Concurrenten in wachtrij',
    COMPETITOR_DISCOVERY_RUNNING: 'Concurrenten zoeken',
    COMPETITOR_REVIEW_REQUIRED: 'Concurrenten controleren',
    SOURCE_COLLECTION_QUEUED: 'Gegevens in wachtrij',
    SOURCE_COLLECTION_RUNNING: 'Gegevens verzamelen',
    NORMALIZATION_RUNNING: 'Gegevens normaliseren',
    RELIABILITY_SCORING_RUNNING: 'Betrouwbaarheid bepalen',
    AI_SYNTHESIS_RUNNING: 'Rapport samenstellen',
    REPORT_BUILD_RUNNING: 'Rapport opbouwen',
    REVIEW_REQUIRED: 'Rapport controleren',
    COMPLETED: 'Afgerond',
    PARTIALLY_COMPLETED: 'Deels afgerond',
    FAILED: 'Mislukt',
    CANCELLED: 'Geannuleerd',
};
export function statusTone(status) {
    if (status === 'COMPLETED')
        return 'success';
    if (status === 'PARTIALLY_COMPLETED')
        return 'warning';
    if (status === 'FAILED')
        return 'error';
    if (status === 'CANCELLED')
        return 'neutral';
    if (status.endsWith('REVIEW_REQUIRED'))
        return 'action';
    if (status.endsWith('RUNNING'))
        return 'running';
    return 'neutral';
}
const TERMINAL_STATUSES = [
    'COMPLETED',
    'PARTIALLY_COMPLETED',
    'FAILED',
    'CANCELLED',
];
/**
 * Is de run bezig (verwerking loopt of staat in de wachtrij)? Wordt gebruikt om
 * de statusweergave te laten pollen tot een controlepunt of eindstatus.
 */
export function isRunActive(status) {
    if (TERMINAL_STATUSES.includes(status))
        return false;
    if (status.endsWith('REVIEW_REQUIRED'))
        return false;
    return true;
}
//# sourceMappingURL=status.js.map